module.exports = "/assets/3fd91e7c3ea79e8bfd9b8d12959af13b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PU.png
// module id = 1729
// module chunks = 0